import { gql, useMutation } from '@apollo/client'
import { useToast } from 'components/Dashboard/Toast'
import { Modal2 } from 'components/Modal'
import SubmitButton from 'components/SubmitButton'
import TextInput from 'components/TextInput'
import { Form, Formik } from 'formik'
import { UncompleteKitMutation, UncompleteKitMutationVariables } from './__generated__/UncompleteKitMutation'

const uncompleteKitMutation = gql`
  mutation UncompleteKitMutation($input: UncompleteKitInput!) {
    uncompleteKit(input: $input) {
      success
      message
      kit {
        id
        status
      }
    }
  }
`

interface UncompleteKitModalProps {
  kitId: string
  onRequestClose: () => void
}

const UncompleteKitModal = ({ kitId, onRequestClose }: UncompleteKitModalProps) => {
  const [uncompleteKit] = useMutation<UncompleteKitMutation, UncompleteKitMutationVariables>(uncompleteKitMutation)

  const { addToast } = useToast()

  return (
    <Modal2 isOpen onRequestClose={onRequestClose} header="Uncomplete Kit">
      <Formik
        initialValues={{ zdRef: '', reason: '' }}
        onSubmit={async (values, { setStatus }) => {
          try {
            const resp = await uncompleteKit({
              variables: {
                input: {
                  kitId,
                  reason: values.reason,
                  zdRef: values.zdRef,
                },
              },
            })

            if (!resp.data.uncompleteKit.success) {
              throw new Error(resp.data.uncompleteKit.message || 'Something went wrong')
            }

            onRequestClose()
            addToast({
              messageType: 'success',
              title: 'Uncompleted',
              content: <>Kit marked uncomplete</>,
              timeout: 5000,
            })
          } catch (err) {
            setStatus({ error: err.message })
          }
        }}
      >
        {({ isSubmitting, status }) => (
          <Form>
            <TextInput name="reason" label="Reason for uncompleting kit" />
            <TextInput name="zdRef" label="Zendesk ticket no (if applicable)" />

            <div className="buttons is-right mt-5">
              <SubmitButton className="is-primary" submitting={isSubmitting} disabled={isSubmitting}>
                Uncomplete Kit
              </SubmitButton>
            </div>
            {status?.error && (
              <article className="message is-danger">
                <div className="message-body">Failed: {status.error}</div>
              </article>
            )}
          </Form>
        )}
      </Formik>
    </Modal2>
  )
}

export default UncompleteKitModal
